import { Component, OnInit, Output, EventEmitter } from '@angular/core'
import { AuthService } from '../../../../services/auth.services'
import { RestServices } from '../../../../services/rest.services'
import { Router } from '@angular/router'
import { SharedServices } from '../../../../services/shared.services'
import { DragulaService } from 'ng2-dragula'
import { notification } from 'onsenui'
@Component({
    selector: 'app-staff',
    templateUrl: './staff.component.html',
    styleUrls: [
        '../../../../stagingcss/main-body.component.css',
        './staff.component.css',
        '../../../../stagingcss/lui-select.component.css'],
})
export class StaffComponent implements OnInit {
    list: any
    listCoppy: any
    str: any
    en = {}
    showEN = true
    infoUser
    nameSortBy =-1
    familyNameSortBy =-1
    roleSortBy =-1
    authSortBy = -1
    dateSortBy = -1
    firstNameSearch =''
    familyNameSearch = ''
    noItem = false
    maxRank = 0
    isDragDrop = true
    @Output() activeHotKey: EventEmitter<any> = new EventEmitter<any>()

    constructor(private authData: AuthService, private router: Router, private restApi: RestServices, private _sharedService: SharedServices, private dragulaService: DragulaService) {
        this.getCommon()
        
        this.dragulaService.destroy('STAFFS')
        
        this.dragulaService.createGroup('STAFFS', {
            // ...
        });
      
        this.dragulaService.dropModel('STAFFS').subscribe((args) => {
            if (this.familyNameSearch === '' && this.firstNameSearch === '') {
                this.isDragDrop = true
            }
        });

    }

    getCommon() {
        // set class display theme
        if(localStorage.getItem('classThemeBody')) {
            jQuery('body').attr('class', localStorage.getItem('classThemeBody'))
        }
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [], status: {
                setting: {
                    map: {
                        common: true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {
                const themeStatus = success['response']['setting']['map']['common']['chooseTheme'] || 'blue'
                if (themeStatus != localStorage.getItem('classThemeBody')) {
                    jQuery('body').attr('class', themeStatus)
                    localStorage.setItem('classThemeBody', themeStatus)
                }
                const checkAddressCommon = success['response']['setting']['map']['common']['address'] || ' '
                const timezone = success['response']['setting']['map']['common']['timezone']
                const countryCode = success['response']['setting']['map']['common']['countryCode']
                if ((!checkAddressCommon || checkAddressCommon === ' ') && (timezone === 'Asia/Tokyo' || timezone === 'Japan' || countryCode === 'JP')) {
                    return this.router.navigateByUrl('/app/main/setting/common')
                }
            })
        })
    }

    ngOnInit() {
        this.familyNameSortBy = -1
        this.nameSortBy = -1
        this.authSortBy = -1
        this.dateSortBy = -1
        this.roleSortBy = -1
        this.firstNameSearch = ''
        this.familyNameSearch = ''

        this._sharedService.changeEmittedSource$.subscribe(
            success => {
                if(!success || !Array.isArray(success)) return
                this.list = success
                this.list = this.list.filter(obj => !obj.deleted);
                this.listCoppy = Object.create(this.list)
                
                if (this.list.length > 0) {
                    this.noItem = true
                    for (let item of this.list) {
                        if (!item.deleted) {
                            this.noItem = false
                            break
                        }
                    }
                    this.list.sort((a, b) =>  (a.rank > b.rank) ? 1 : -1)
                    this.maxRank = this.list.length
                    let rank = 1
                    this.list.forEach(staff => {
                        staff.rank = rank
                        let idStaff = staff._id
                        this.updateRankStaff(idStaff, rank)
                        rank++
                    });
                } else {
                    this.noItem = true
                }
                this.onChangInputValue()
            })
        this.mainClient()
    }

    // list staff
    mainClient() {
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [],
            status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                    searches: {
                        '{"deleted": {"$ne": true}}': true
                    }
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    this.list = success['response']['staff']['searches']["{\"deleted\": {\"$ne\": true}}"]
                    this.infoUser = success['user']['roles']
                    this.listCoppy = success['response']['staff']['paths']['{}']
                    if (this.list) {
                        this.list.sort((a, b) =>  (a.rank > b.rank) ? 1 : -1)
                        this.maxRank = this.list.length
                    }
                },
            )
        })
    }

    editStaff(idStaff) {
        const arrStaff = [idStaff, 'activeStaffEdit']
        this._sharedService.emitChange(arrStaff)
    }

    newStaff() {
        this._sharedService.emitChange([this.maxRank, 'active'])
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    nameSort() {
        this.familyNameSortBy = -1  // reset to unsort value
        this.roleSortBy = -1  // reset to unsort value
        this.authSortBy = -1   // reset to unsort value
        this.dateSortBy = -1   // reset to unsort value
        this.isDragDrop = false
        let tempSort = Object.create(this.list)

        if (this.nameSortBy == 0) {
            this.nameSortBy = 1
        }
        else {
            this.nameSortBy = 0
        }
        this.reorderByName(this.nameSortBy)
    }
    reorderByName(orderValue) {
        let tempSort = Object.create(this.list)

        if (orderValue == 1) {
           
            tempSort = tempSort.sort(function (a, b) {

                if (!a.firstName || !b.firstName) {
                    if (!a.firstName && !b.firstName) {
                        if(!b.createTime){ return -1}

                    return a.createTime === b.createTime ? 0 : a.createTime < b.createTime ? -1 : 1;  
                    }
                    return a.firstName === b.firstName ? 0 : a.firstName < b.firstName ? -1 : 1;
                }

                if (a.firstName.toLowerCase() === b.firstName.toLowerCase()) {
                    if(!a.createTime || !b.createTime){                                          
                        return -1
                    }

                    return a.createTime === b.createTime ? 0 : a.createTime < b.createTime ? -1 : 1;
                }
                // a -z case
                return  a.firstName.toLowerCase() < b.firstName.toLowerCase() ? -1 : 1;
            })

            tempSort = tempSort.sort(function (a, b) {
                if (!b.firstName && a.firstName) {
                    return -1
                } else { return 0 }
            })

            this.list = tempSort

        } else {
           
            tempSort = tempSort.sort(function (a, b) {
                if (!b.firstName && a.firstName) {
                    return -1
                } else { return 0 }
            })

            tempSort = tempSort.sort(function (a, b) {
     
                if (!a.firstName || !b.firstName) {
                    if (!a.firstName && !b.firstName) {
                        if(!b.createTime){ return -1}
                        
                        return a.createTime === b.createTime ? 0 : a.createTime > b.createTime ? -1 : 1; 
                    }
                    return a.firstName === b.firstName ? 0 : a.firstName > b.firstName ? -1 : 1;
                }
                if (a.firstName.toLowerCase() === b.firstName.toLowerCase()) {
                    if(!a.createTime || !b.createTime){                      
                        return -1
                    }
                    return a.createTime === b.createTime ? 0 : a.createTime > b.createTime ? -1 : 1;
                }
                // z -a case
                return  a.firstName.toLowerCase() > b.firstName.toLowerCase() ? -1 : 1;
            })

            this.list = tempSort
        }      
    }

    familyNameSort() {
        this.nameSortBy = -1  // 
        this.roleSortBy = -1  // 
        this.authSortBy = -1   // 
        this.dateSortBy = -1   //
        this.isDragDrop = false
        let tempSort = Object.create(this.list)
        if (this.familyNameSortBy == 0) {
            this.familyNameSortBy = 1
        }
        else {
        this.familyNameSortBy = 0
        }
        this.reorderByFname(this.familyNameSortBy)
    }
    reorderByFname(orderValue) {
        let tempSort = Object.create(this.list)

        if (orderValue == 1) {
           

            tempSort = tempSort.sort(function (a, b) {           


                if (!a.familyName || !b.familyName) {
                    if (!a.familyName && !b.familyName) {
                        if(!b.createTime){ return -1}

                        return a.createTime === b.createTime ? 0 : a.createTime < b.createTime ? -1 : 1;
                    }
                    
                    return a.familyName === b.familyName ? 0 : a.familyName < b.familyName ? -1 : 1;
                }
                if (a.familyName.toLowerCase() === b.familyName.toLowerCase()) {
                    if(!a.createTime || !b.createTime){
                        return -1
                    }
                    return a.createTime === b.createTime ? 0 : a.createTime < b.createTime ? -1 : 1;
                }
                // a- z case
                return  a.familyName.toLowerCase() < b.familyName.toLowerCase() ? -1 : 1;
            })

            tempSort = tempSort.sort(function (a, b) {
                if (!b.familyName && a.familyName) {
                    return -1
                } else { return 0 }
            })

            this.list = tempSort

        } else {
            

            tempSort = tempSort.sort(function (a, b) {
                if (!b.familyName && a.familyName) {
                    return -1
                } else { return 0 }
            })

            tempSort = tempSort.sort(function (a, b) {               

                if (!a.familyName || !b.familyName) {
                    if (!a.familyName && !b.familyName) {
                        if(!b.createTime){ return -1}

                      return a.createTime === b.createTime ? 0 : a.createTime > b.createTime ? -1 : 1;
                    }
                    return a.familyName === b.familyName ? 0 : a.familyName > b.familyName ? -1 : 1;
                }

                if (a.familyName.toLowerCase() === b.familyName.toLowerCase()) {
                    if(!a.createTime || !b.createTime){              
                        return -1
                    }
                    return a.createTime === b.createTime ? 0 : a.createTime > b.createTime ? -1 : 1;
                }

                // Z - A case
                return  a.familyName.toLowerCase() > b.familyName.toLowerCase() ? -1 : 1;
            })

            this.list = tempSort
        }
    }


    roleSort() {
        this.familyNameSortBy =-1
        this.nameSortBy = -1
        this.authSortBy = -1
        this.dateSortBy = -1
        this.isDragDrop = false
        if (this.roleSortBy == 0) {
            this.roleSortBy = 1
        }
        else {
            this.roleSortBy = 0
        }
        this.reorderByRole(this.roleSortBy)
    }

    authSort() {
        this.nameSortBy = -1
        this.familyNameSortBy = -1
        this.roleSortBy = -1
        this.dateSortBy = -1
        this.isDragDrop = false
        let tempSort = Object.create(this.list)

        if (this.authSortBy == 0) {
            this.authSortBy = 1
        } else {
            this.authSortBy = 0
        }
        this.reorderByAuth(this.authSortBy)
    }
    reorderByAuth(orderValue) {
        let tempSort = Object.create(this.list)

        if (orderValue == 1) {
            
            tempSort = tempSort.sort(function (a, b) {
                let pointA = 0
                let pointB = 0

                if (a.passwordAuthentiction == true) {
                    pointA = pointA+1
                } else {
                    pointA = pointA + 5
                }

                if (a.hasOwnProperty('createTime')){
                    pointA = pointA+1
                }
                
                if (b.passwordAuthentiction == true) {
                    pointB = pointB+1
                } else {
                    pointB = pointB + 5
                }
                
                if (b.hasOwnProperty('createTime')){
                    pointB = pointB+1
                }

                if (pointA == pointB) {
                    return a.createTime === b.createTime ? 0 : a.createTime < b.createTime ? -1 : 1;
                }
                return pointB > pointA ? 1 : -1;
            })

        } else {
            
            tempSort = tempSort.sort(function (a, b) {

                let pointA = 0
                let pointB = 0

                if (a.passwordAuthentiction == true) {
                    pointA = pointA + 5
                } else {
                    pointA = pointA + 1
                }
                
                if (a.hasOwnProperty('createTime')){
                    pointA = pointA+1
                }

                if (b.passwordAuthentiction == true) {
                    pointB = pointB + 5
                } else {
                    pointB = pointB + 1
                }
                
                if (b.hasOwnProperty('createTime')){
                    pointB = pointB+1
                }        

                if (pointA === pointB) {
                    return a.createTime === b.createTime ? 0 : a.createTime > b.createTime ? -1 : 1;
                }
                return pointB > pointA ? 1 : -1;
            })
        }

        this.list = tempSort


    }

    dateSort() {
        this.nameSortBy = -1
        this.familyNameSortBy = -1
        this.roleSortBy = -1
        this.authSortBy = -1
        if (this.dateSortBy == 0) {
            this.dateSortBy = 1
        } else {
            this.dateSortBy = 0
        }
        this.reorderDate(this.dateSortBy)
    }


    reorderDate(sortOrder) {
        this.isDragDrop = false
        let tempSort = Object.create(this.list)

        tempSort = tempSort.sort(function (a, b) {
            if (!b.createTime && a.createTime) {
                return -1
            } else { return 0 }
        })

        if (sortOrder == 1) {
            
            tempSort = tempSort.sort(function (a, b) {
                return a.createTime === b.createTime ? 0 : a.createTime < b.createTime ? -1 : 1;
            })

        } else {
            
            tempSort = tempSort.sort(function (a, b) {
                return a.createTime === b.createTime ? 0 : a.createTime > b.createTime ? -1 : 1;
            })
        }

    
        this.list = tempSort

    }

    reorderByRole(sort) {

        this.list = this.list.sort(function (a, b) {
            let pointA = 0
            let pointB = 0

            if (a.roles.includes('administrator')) {
                pointA = pointA + 5
            }
            if (a.roles.includes('cordinator')) {
                pointA = pointA + 2
            }
            if (a.roles.includes('doctor')) {
                pointA = pointA + 1
            }

            if (b.roles.includes('administrator')) {
                pointB = pointB + 5
            }
            if (b.roles.includes('cordinator')) {
                pointB = pointB + 2
            }
            if (b.roles.includes('doctor')) {
                pointB = pointB + 1
            }

            if (sort == 0) {
                if (pointA > pointB) return -1
                if (pointA === pointB) {
                    return a.createTime === b.createTime ? 0 : a.createTime > b.createTime ? -1 : 1;
                }
                if (pointA < pointB) return 1
            } else {
                if (pointA > pointB) return 1
                if (pointA === pointB) {
                    return a.createTime === b.createTime ? 0 : a.createTime < b.createTime ? -1 : 1;
                }
                if (pointA < pointB) return -1
            }

        })
    }

    focusInput(event) {
        this.activeHotKey.emit(true)
    }

    blurInput(event) {
        this.activeHotKey.emit(false)
    }

    onChangInputValue() {
        
        this.roleSortBy = -1
        this.nameSortBy = -1
        this.familyNameSortBy = -1
        this.authSortBy = -1
        this.isDragDrop = false
        let tempSearch = this.listCoppy
        if (this.familyNameSearch === '' && this.firstNameSearch === '') {
            this.isDragDrop = true
        }
        if (this.firstNameSearch !== '') {
            tempSearch = tempSearch.filter(item => {
                return item.firstName ? item.firstName.toLowerCase().includes(this.firstNameSearch.toLowerCase()) : false
            })
        }
        if (this.familyNameSearch !== '') {
            tempSearch = tempSearch.filter(item => {
                return item.familyName ? item.familyName.toLowerCase().includes(this.familyNameSearch.toLowerCase()) : false
            })
        }

        if (tempSearch.length > 0) {
            this.noItem = false
        } else {
            this.noItem = true
        }
    
        this.list = tempSearch
        if (this.list.length > 0) {
            this.noItem = true
            for (let item of this.list) {
                if (!item.deleted) {
                    this.noItem = false
                    break
                }
            }

        } else {
            this.noItem = true
        }
        this.reorderSort()

    }

    reorderSort() {
        if (this.roleSortBy != -1) {
            this.reorderByRole(this.roleSortBy)
        }
        if (this.nameSortBy != -1) {
            this.reorderByName(this.nameSortBy)
        }
        if (this.familyNameSortBy != -1) {
            this.reorderByFname(this.familyNameSortBy)
        }
        if (this.authSortBy != -1) {
            this.reorderByAuth(this.authSortBy)
        }
        if (this.dateSortBy != -1) {
            this.reorderDate(this.dateSortBy)
        }
    }
    
    updateRankStaff(idStaff, rankNew) {
        const resourceUrl = 'resource'
        const valueData = {rank: rankNew}
        const resourceData = {
            actions: [{
                type: 'update', id: idStaff, collection: 'staff', value: valueData,
            }],
            status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    
                },
            )
        })
    }


    saveDragDrop() {

        this.changeLanguage()
        notification.confirm({
            message: this.en['alert-content-save'],
            title: '<b>' + this.en['alert-save'] + '</b>',
            cancelable: true,
            buttonLabels: [this.en['alert-cancel'], 'OK'],
            callback: i => {
                if (i === 1) {  // here this is not cancelled.  1 is correct.
                    if (this.list) {
                        let rank = 1
                        this.list.forEach(staff => {
                            staff.rank = rank
                            let idStaff = staff._id
                            this.updateRankStaff(idStaff, rank)
                            rank++
                        });
                    }
                }
            },
        })

    }



}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/setting/staff/staff.component.ts